interface LoginCallbackParams {
  access_token: string
  streaming_service: string
  mode: string
  new_user: boolean
}

export function parseUrlToken (): LoginCallbackParams|null {
  const params = new URLSearchParams(window.location.search)
  const [access_token, streaming_service, mode, new_user] = [
    params.get('access_token'),
    params.get('streaming_service'),
    params.get('mode'),
    params.get('new_user') === 'true',
  ]
  if (access_token && streaming_service && mode) {
    return { access_token, streaming_service, mode, new_user }
  }
  return null
}

/**
  * Remove all spotify login callback params from the URL
  */
export function removeUrlToken (): void {
  const url = new URL(window.location.href)
  url.searchParams.delete('access_token')
  url.searchParams.delete('streaming_service')
  url.searchParams.delete('mode')
  url.searchParams.delete('new_user')
  url.searchParams.delete('service_token')
  window.history.replaceState({}, '', url.toString())
}
